import React, { useState } from 'react'

import MainModal from '../../../modal/MainModal'
import Flex from '../../../../layouts/Flex'

import RichTextbox from '../../../controls/RichTextBox'

import { P } from '../../../../../style/Typography.style'

import QuestionLogs from './QuestionLogs'

const UpdateQuestionNotes = ({
  answeredQuestions,
  setAnsweredQuestions,
  currentQuestion,
  setNoteModal,
}) => {
  const [notes, setNotes] = useState(currentQuestion[0]?.notes || '<p><br></p>')
  const [guideQuestions, setGuideQuestions] = useState(
    currentQuestion[0]?.guide_questions || '<p><br></p>'
  )

  const handleChangeNotes = (e) => {
    setNotes(e)
  }

  const handleChangeGuideQuestions = (e) => {
    setGuideQuestions(e)
  }

  const handleUpdate = () => {
    const updatedQuestion = {
      ...currentQuestion[0],
      notes,
      guide_questions: guideQuestions,
    }
    const updatedQuestions = answeredQuestions.map((q) => {
      if (
        parseInt(q.question_id) === parseInt(currentQuestion[0]?.question_id)
      ) {
        return updatedQuestion
      }
      return q
    })
    setAnsweredQuestions(updatedQuestions)
    handleClose()
  }

  const handleClose = () => {
    // close notes modal without closing the parent modal
    return setNoteModal(false)
  }

  return (
    <MainModal
      title="Update Question"
      onClick={handleUpdate}
      buttonText="Submit"
      onClose={handleClose}
    >
      <Flex gap="0.4rem" direction="column">
        <P>Guide Questions</P>
        <RichTextbox
          content={guideQuestions}
          setContent={handleChangeGuideQuestions}
        />
        <P>Notes</P>
        <RichTextbox content={notes} setContent={handleChangeNotes} />
        <QuestionLogs
          id={currentQuestion[0]?.question_id}
          interview_id={currentQuestion[0]?.interview_id}
        />
      </Flex>
    </MainModal>
  )
}

export default UpdateQuestionNotes
